import Placeholder from '../components/Placeholder';

export default function Login() {
  return (
    <Placeholder title="Login Page" />
  );
}
